"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ASSET_UPLOADER_STUDIO_CLIENT_ID = exports.RCV_JWT = exports.ASSET_API_URL = exports.STUDIO_API_URL = exports.STUDIO_CLIENT_URL = exports.STUDIO_APP_JWT_EXPIRES_TIME = exports.STUDIO_APP_JWT = void 0;
exports.STUDIO_APP_JWT = 'studioAppJWT';
exports.STUDIO_APP_JWT_EXPIRES_TIME = 'studioAppJWTExpiresTime';
exports.STUDIO_CLIENT_URL = 'https://studio.manifold.xyz';
exports.STUDIO_API_URL = 'https://studio.api.manifoldxyz.dev';
exports.ASSET_API_URL = 'https://uploader.api.manifoldxyz.dev';
exports.RCV_JWT = 'receive-jwt';
exports.ASSET_UPLOADER_STUDIO_CLIENT_ID = 1;
//# sourceMappingURL=constant.js.map